// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kN","tag":"kO","isRental":"kP","title":"kQ","title2":"kR","description":"kS","cta":"kT","ratingLabel":"kU","ratingLabelSmallScreen":"kV","iconInHotspotVideo":"kW"};